// export const RestrictedToRole = ({ allowedRole, children }) => {
//   const { role } = useRole();
//   return role === allowedRole ? children : null;
// };
//import {useRole} from './RoleContext';
export const RestrictedToRole = ({ allowedRoles, children }) => {
  const role = localStorage.getItem('userRole');
  return allowedRoles.includes(role) ? children : null;
};
